import { PhotoProvider, PhotoView } from 'react-photo-view';
import gallery from '../mocks/gallery.json';
import 'react-photo-view/dist/react-photo-view.css';

const Gallery = () => {
    if (!gallery) {
        return <p>Caricamento immagini...</p>;
    }

    return (
        <section className='page-section bg-light' id='gallery'>
            <div className='container' data-aos='fade-up'>
                <h2 className='section-heading text-center text-uppercase mb-5'>Galleria</h2>

                <PhotoProvider>
                    <div className='row'>
                        {gallery.map((item, index) => (
                            <div key={index} className='col-lg-4 col-sm-6 mb-4'>
                                <PhotoView src={item.path}>
                                    <img
                                        className='img-fluid'
                                        src={item.path}
                                        alt={item.alt || `Immagine ${index + 1}`}
                                        style={{ cursor: 'pointer' }}
                                    />
                                </PhotoView>
                            </div>
                        ))}
                    </div>
                </PhotoProvider>
            </div>
        </section>
    );
};
export default Gallery;
